import React, { useState, useEffect } from 'react';
import authService from '../../api-authorization/AuthorizeService';
import axios from 'axios';
import "bootstrap/dist/css/bootstrap.min.css"; //https://www.creative-tim.com/blog/web-design/how-to-use-bootstrap-with-reactjs/
import createCache from '@emotion/cache';
import LoadingButton from '@mui/lab/LoadingButton';
import { Link, useLocation } from 'react-router-dom'
import queryString from 'query-string'
import { trackPromise } from 'react-promise-tracker';
import { usePromiseTracker } from "react-promise-tracker";
import { Switch, Checkbox, Button, TextField, Modal, Box, Grid, Stack, Typography, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormGroup, FormControl, FormLabel, FormControlLabel, Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Moment from 'moment';
import { Bars, MagnifyingGlass } from "react-loader-spinner";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

export default function UpdateEventGames(props) {

    const { search } = useLocation()
    const values = queryString.parse(search)
    
    const [status, setStatus] = useState("");
    const [eventName, setEventName] = useState(props.eventName ? props.eventName : (values.eventName ? values.eventName : "" ));
    const [gameSource, setGameSource] = useState(props.gameSource ? props.gameSource : (values.gameSource ? values.gameSource : ""));
    const [exactMatchEventName, setExactMatchEventName] = useState(props.exactMatchEventName === undefined ? (values.exactMatchEventName === undefined ? true : values.exactMatchEventName) : props.exactMatchEventName);
    var today = Moment().add(1, 'days').format("YYYY-MM-DD");
    var lastMonth = Moment().add(-1, 'months').format("YYYY-MM-DD");
    const [eventStartDate, setEventStartDate] = useState(props.eventStartDate ? props.eventStartDate : (values.eventStartDate ? values.eventStartDate : lastMonth));
    const [eventEndDate, setEventEndDate] = useState(props.eventEndDate ? props.eventEndDate : (values.eventEndDate ? values.eventEndDate : today) );
    const [uscfEventId, setUscfEventId] = useState(-1);
    const [fideEventId, setFideEventId] = useState(-1);
    const [newEventName, setNewEventName] = useState("");
    const [newUSCFEventId, setNewUSCFEventId] = useState(-1);
    const [newFIDEEventId, setNewFIDEEventId] = useState(-1);
    

    const { promiseInProgress } = usePromiseTracker();
    const [statusColor, setStatusColor] = useState();
    const [token, setToken] = useState();
    const [authenticated, setAuthenticated] = useState(false);
    const [games, setGames] = useState([]);
    const [eventGames, setEventGames] = useState([]);
    const [downloading, setDownloading] = useState(false);
    const [waiting, setWaiting] = useState(false);
    const [searching, setSearching] = useState(false);
    const [blankDate, setBlankDate] = useState("");
    
    const centerDivStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '20vh'
    }; //https://www.c-sharpcorner.com/blogs/how-to-make-a-div-center-in-screen-in-react-js

    useEffect(async (e) => {
        setAuthenticated(await authService.isAuthenticated());
        var ttt = await authService.getAccessToken();
        await setToken(ttt);
        
        //setEventStartDate(lastMonth);
        //setEventEndDate(today);
        if (eventName && eventStartDate && eventEndDate) {
            findEventGames()
        }
            
    }, []);

    const findEventGames = async () => {
        //e.preventDefault();
        var t = await authService.getAccessToken();
        var headers = {
            headers: { 'Authorization': `Bearer ${t}` }
        }
        trackPromise(
            axios.get('/api/chessgames/GetEventGames?eventName=' + encodeURIComponent(eventName) + '&eventStartDate=' + eventStartDate + '&eventEndDate=' + eventEndDate + '&exactMatchEventName=' + exactMatchEventName + '&gameSource=' + gameSource, headers).then((response) => {
                let playergames = response.data;
                setEventGames(playergames);
                setGames(playergames);
                setDownloading(false);
                if (playergames.length > 0) {
                    setStatusColor("green");
                    setStatus(playergames.length + " Games found.");
                } else {
                    setStatusColor("red");
                    setStatus("No games found");
                }
                    
            }).catch((error) => {
                setDownloading(false);
                setStatusColor("red");
                setStatus(error.response.data);
                console.log(error.response.data);
            })
        )
        
    };

    const updateEventGames = async () => {
        //e.preventDefault();
        var t = await authService.getAccessToken();
        var headers = {
            headers: { 'Authorization': `Bearer ${t}` }
        }

        trackPromise(
            axios.patch('/api/chessgames/UpdateEventGames?eventName=' + encodeURIComponent(eventName) + '&eventStartDate=' + eventStartDate + '&eventEndDate=' + eventEndDate + '&exactMatchEventName=' + exactMatchEventName + '&newEventName=' + encodeURIComponent(newEventName) + '&newUSCFEventId=' + newUSCFEventId + '&newFIDEEventId=' + newFIDEEventId + '&blankDate=' + blankDate + '&gameSource=' + gameSource, null, headers).then((response) => {
                let playergames = response.data;
                setEventGames(playergames);
                setGames(playergames);
                setDownloading(false);
                if (playergames.length > 0) {
                    setStatusColor("green");
                    setStatus(playergames.length + " Games found.");
                } else {
                    setStatusColor("red");
                    setStatus("No games found");
                }

            }).catch((error) => {
                setDownloading(false);
                setStatusColor("red");
                setStatus(error.response.data);
                console.log(error.response.data);
            })
        )

    };

    return (

        <div>
            <Accordion m={2} pt={3} pl={3} pr={3} defaultExpanded={true}>
                <AccordionSummary aria-controls="event-info" id="event-info" expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#1976d2'}}>
                    <Typography color='white'>Search and Update Event Games</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container direction="row" rowSpacing={1} columnSpacing={1} justify-content="space-between" align-items="stretch">
                        <Grid item xs={12} lg={12}>
                            <Stack>
                                <span>{'Search Criteria : '+
                                    (eventName ? 'Event Name ' : '') + (eventName && (exactMatchEventName ? " is " : "starts with ")) + (eventName ? eventName : '') + (gameSource ? ' Game Source is ' + gameSource : '') + (eventStartDate ? ' Starts on ' + eventStartDate : '') + (eventEndDate ? " Ends on " + eventEndDate : '')}
                                    <span style={{ color: statusColor }}>{status ? ' ' + status : ''}</span>
                                </span>
                            </Stack>
                        </Grid>
                        <Grid item xs={6} lg={3}>
                            <Stack>
                                <TextField
                                    required
                                    fullwidth="true"
                                    size="small"
                                    label={exactMatchEventName ? 'Event Name Is ' : 'Event Name Starts With'}
                                    InputLabelProps={{ shrink: true, }}
                                    variant='outlined'
                                    value={eventName}
                                    onChange={async (e) => { setEventName(e.target.value) }}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={6} lg={2}>
                            <Stack>
                                <FormControlLabel fullwidth="true" control={<Switch checked={exactMatchEventName} onChange={async (e) => {setExactMatchEventName(e.target.checked) }} />} label="Exact Match" />
                            </Stack>
                        </Grid>
                        <Grid item xs={6} lg={2}>
                            <Stack>
                                <TextField
                                    fullwidth="true"
                                    size="small"
                                    label={'Game Source'}
                                    InputLabelProps={{ shrink: true, }}
                                    variant='outlined'
                                    value={gameSource}
                                    onChange={async (e) => { setGameSource(e.target.value) }}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={6} lg={2}>
                            <Stack>
                                <TextField
                                    required
                                    fullwidth="true"
                                    size="small"
                                    label='Start Date'
                                    InputLabelProps={{ shrink: true, }}
                                    variant='outlined'
                                    type='date'
                                    value={eventStartDate}
                                    onChange={async (e) => { setEventStartDate(e.target.value) }}
                                    error={!eventStartDate}
                                    helperText={!eventStartDate ? 'Required' : ''}
                                    defaultValue={eventStartDate}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={6} lg={2}>
                            <Stack>
                                <TextField
                                    required
                                    fullwidth="true"
                                    size="small"
                                    label='End Date'
                                    InputLabelProps={{ shrink: true, }}
                                    variant='outlined'
                                    type='date'
                                    value={eventEndDate}
                                    onChange={async (e) => { setEventEndDate(e.target.value) }}
                                    error={!eventEndDate}
                                    helperText={!eventEndDate ? 'Required' : ''}
                                    defaultValue={eventEndDate}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={12} lg={1}>
                            <Stack>
                                <LoadingButton
                                    onClick={async (e) => { await setDownloading(true); await findEventGames(); }}
                                    loading={downloading}
                                    disabled={!eventName || eventName.length <=2}
                                    loadingIndicator="Wait"
                                    variant="contained"
                                    color="primary"
                                >
                                    Search
                                </LoadingButton>
                            </Stack>
                        </Grid>

                    </Grid>
                </AccordionDetails>
                <AccordionDetails>
                    {games.length > 0 &&
                        <Grid container direction="row" rowSpacing={1} columnSpacing={1} justify-content="space-between" align-items="stretch">
                            <Grid item xs={6} lg={5}>
                                <Stack>
                                    <TextField
                                        required
                                        fullwidth="true"
                                        size="small"
                                        label={'New Event Name'}
                                        InputLabelProps={{ shrink: true, }}
                                        variant='outlined'
                                        value={newEventName}
                                        onChange={async (e) => { setNewEventName(e.target.value) }}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={6} lg={2}>
                                <Stack>
                                    <TextField
                                        fullwidth="true"
                                        size="small"
                                        label='Set Games with Blank Date'
                                        InputLabelProps={{ shrink: true, }}
                                        variant='outlined'
                                        type='date'
                                        value={blankDate}
                                        onChange={async (e) => { setBlankDate(e.target.value) }}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={6} lg={2}>
                                <Stack>
                                    <TextField
                                        required
                                        fullwidth="true"
                                        size="small"
                                        label={newUSCFEventId > -1 ? <a href={'https://www.uschess.org/msa/XtblMain.php?' + newUSCFEventId} target='_blank' rel='noreferrer'>{'USCF Event ' + newUSCFEventId}</a>:'New USCF Event ID'}
                                        InputLabelProps={{ shrink: true, }}
                                        variant='outlined'
                                        value={newUSCFEventId}
                                        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} 
                                        onChange={async (e) => { setNewUSCFEventId(e.target.value ? e.target.value : -1) }}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={6} lg={2}>
                                <Stack>
                                    <TextField
                                        required
                                        fullwidth="true"
                                        size="small"
                                        label={newFIDEEventId > -1 ? <a href={'https://ratings.fide.com/tournament_information.phtml?event=' + newFIDEEventId} target='_blank' rel='noreferrer'>{'FIDE Event ' + newFIDEEventId}</a> : 'New FIDE Event ID'}
                                        InputLabelProps={{ shrink: true, }}
                                        variant='outlined'
                                        value={newFIDEEventId}
                                        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} 
                                        onChange={async (e) => { setNewFIDEEventId(e.target.value ? e.target.value : -1) }}
                                    />
                                </Stack>
                            </Grid>

                            <Grid item xs={12} lg={1}>
                                <Stack>
                                    <LoadingButton
                                        onClick={async (e) => { await setDownloading(true); await updateEventGames(); }}
                                        loading={downloading}
                                        disabled={!eventName}
                                        loadingIndicator="Wait"
                                        variant="contained"
                                        color="primary"
                                    >
                                        Update
                                    </LoadingButton>
                                </Stack>
                            </Grid>

                        </Grid>
                    }
                </AccordionDetails>
                <AccordionDetails>
                        {(promiseInProgress === true) ?
                            <div>
                                <Box sx={{ pt: 2, pb: 1 }}>
                                    <div style={centerDivStyle}>
                                        <MagnifyingGlass ariaLabel="Loading" color="#00BFFF" />
                                    </div>
                                </Box>
                            </div>
                            :
                            <div>
                                {games.length > 0 &&
                                    <div>
                                        <TableContainer component={Paper}>
                                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="left">Date</TableCell>
                                                        <TableCell align="left">Event</TableCell>
                                                        <TableCell align="left">White</TableCell>
                                                        <TableCell align="left">Elo</TableCell>
                                                        <TableCell align="left">Result</TableCell>
                                                        <TableCell align="left">Elo</TableCell>
                                                        <TableCell align="left">Black</TableCell>
                                                        <TableCell align="left">USCFEventID</TableCell>
                                                        <TableCell align="left">FIDEEventID</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {games.map((game) => (
                                                        <TableRow
                                                            key={game.gameHash}
                                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                        >
                                                            {/*<TableCell component="th" scope="row"><span>{game.date}</span></TableCell>*/}
                                                            <TableCell align="right">{game.fideEventId > 0 ? <a target="_blank" href={"https://ratings.fide.com/view_games.phtml?event=" + game.fideEventId} >{game.date}</a> : game.date}</TableCell>
                                                            <TableCell align="right">{game.fideEventId > 0 ? <Link target="_blank" to={'/Games/GamesByEventID?idType=FIDE&id=' + game.fideEventId}>{game.event}</Link>
                                                                : (game.uscfEventId > 0 ? <Link target="_blank" to={'/Games/GamesByEventID?idType=USCF&id=' + game.uscfEventId}>{game.event}</Link> : game.event)}
                                                            </TableCell>
                                                            <TableCell align="right">{game.whiteFIDEID > 0 ? <a target="_blank" href={"https://ratings.fide.com/profile/" + game.whiteFIDEID + "/calculations"} >{game.white}</a> : game.white}</TableCell>
                                                            <TableCell align="right">{game.whiteUSCFID > 0 ? <a target="_blank" href={"https://ratings.uschess.org/player/" + game.whiteUSCFID} >{game.whiteElo}</a> : game.whiteElo}</TableCell>
                                                            <TableCell align="right">{<Link target="_blank" to={'/games/GameByID/' + game.gameHash}>{game.result}</Link>} </TableCell>
                                                            <TableCell align="right">{game.blackUSCFID > 0 ? <a target="_blank" href={"https://ratings.uschess.org/player/" + game.blackUSCFID} >{game.blackElo}</a> : game.blackElo}</TableCell>
                                                            <TableCell align="right">{game.blackFIDEID > 0 ? <a target="_blank" href={"https://ratings.fide.com/profile/" + game.blackFIDEID + "/calculations"} >{game.black}</a> : game.black}</TableCell>
                                                            <TableCell align="right">{game.uscfEventId > 0 ? <a target="_blank" href={"https://www.uschess.org/msa/XtblMain.php?" + game.uscfEventId} >{game.uscfEventId}</a> : game.uscfEventId}</TableCell>
                                                            <TableCell align="right">{game.fideEventId > 0 ? <a target="_blank" href={"https://ratings.fide.com/tournament_information.phtml?event=" + game.fideEventId} >{game.fideEventId}</a> : game.fideEventId}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                }
                            </div>

                        }
                </AccordionDetails>
            </Accordion>
        </div>

    )
}
